<template>
    <div>
        <img :src="'/media/header/profil.jpg'" alt="Profil" class="img-fluid mb-4 rounded">
<!--        <page-header :title="$t('pages.account.title')" icon-class="mdi mdi-account"/>-->

        <div class="row mb-4">
            <div class="col-md-4 col-lg-3">
                <div class="list-group shadow-sm">
                    <router-link tag="a" :to="link.route" class="list-group-item d-flex justify-content-between align-items-center oswald text-primary"
                                 :class="{active: isActive(link)}"
                                 v-if="canSeeLink(link)"
                                 v-for="link in links" :key="link.title">
                        {{ link.title }}
                        <span class="badge badge-primary badge-dark">
                            <i class="mdi mdi-18px" :class="link.icon"></i>
                        </span>
                    </router-link>
                </div>
            </div>

            <div class="col-md-8 col-lg-9">
                <transition name="component-fade" mode="out-in">
                    <router-view></router-view>
                </transition>
            </div>
        </div>

    </div>
</template>

<script>
import AccountRepository from "../../repositories/Account/AccountRepository";
import AccountDataViewEdit from "./Includes/AccountDataViewEdit";
import PageHeader from "../Includes/PageHeader";
export default {
    name: "Account",
    components: {PageHeader, AccountDataViewEdit},
    computed: {
        links() {
            return [
                {
                    icon: 'mdi-account',
                    title: this.$t('pages.account.info.title'),
                    route: {name: 'account.info'},
                },
                {
                    icon: 'mdi-truck-delivery',
                    title: this.$t('pages.account.address.title'),
                    route: {name: 'account.address'},
                    requiresSubscription: true,
                    activeWord: 'address'
                },
                {
                    icon: 'mdi-mine',
                    title: this.$t('pages.subscription.title'),
                    route: {name: 'subscription'},
                    activeWord: 'subscription'
                },
                {
                    icon: 'mdi-heart',
                    title: this.$t('pages.account.health.title'),
                    route: {name: 'account.health'},
                    requiresSubscription: true,
                },
                {
                    icon: 'mdi-frequently-asked-questions',
                    title: this.$t('pages.faq.title_long'),
                    route: {name: 'account.faq'}
                },
                {
                    icon: 'mdi-lock',
                    title: this.$t('pages.account.change_password.title'),
                    route: {name: 'account.password.change'}
                },
            ];
        }
    },
    methods: {
        isActive(link) {
            if(link.activeWord === undefined)
                return (this.$route.name === link.route.name);

            return this.$route.name.includes(link.activeWord);
        },
        canSeeLink(link) {
            let canSee = true;

            if(link.requiresSubscription && !this.$store.getters.isSubscribed)
                canSee = false;

            return canSee;
        },
    }

}
</script>

<style scoped>

</style>
